





















































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class FinePrintIcon extends Vue {
  @Prop({ default: '24' }) readonly size?: string;
  @Prop({ default: '#405F7A' }) readonly color?: string;
}
